export default {
    bind(el, binding) {
        el.addEventListener('click', () => {
            const [action, event_category, event_label, value] = binding.value;
            if (typeof window.gtag !== 'undefined') {
                window.gtag('event', action, {event_category, event_label, value});
            }
        }, { passive: true });
    },
}
